export default __webpack_public_path__ + "static/15-cce47479f2600316fddd02beb6669358.png";